import logo from './logo.svg';
import './App.css';
import MyLeagues from "./Layouts/MyLeagues/MyLeagues.jsx";
import RDP from "./Layouts/RDP/RDP.jsx";
import WaiverClaims from './Layouts/WaiverClaims/WaiverClaims.jsx';
import Lineups from './Layouts/Lineups/Lineups.jsx';
import MyDash from "./Layouts/MyLeagues/MyDash.jsx";
import MyRosters from "./Layouts/MyLeagues/MyRosters.jsx";
import MflLeagues from "./Layouts/MyLeagues/mflLeagues.jsx";
import Admin from "./Layouts/MyLeagues/Admin.jsx";
import Projections from "./Layouts/Projections/Projections.jsx";
import ProjectionsPosition from "./Layouts/Projections/ProjectionsPosition.jsx";
import PropBets from "./Layouts/PropBets/PropBets.jsx";
import TradeCenter from "./Layouts/TradeCenter/TradeCenter.jsx";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  Link,
} from "react-router-dom";
import { SideBar, LoginForm } from "./components";
import React, { useEffect, useContext,useState } from "react";
import { Spin } from "antd";
import { UserContext } from "./Contexts/UserContext";
import history from "./components/History";
import IdleTimerContainer from "./components/IdleTimerContainer";

function App() {
  const { username, userLoading, timeout, setUsername, setTimeout } =
    useContext(UserContext);
  useEffect(() => {}, []);
  const [pathname,setPathname]= useState(window.location.pathname);
  window.onbeforeunload = function(e) {
    setPathname(window.location.pathname)
 };
  console.log(parseFloat(timeout), Math.floor(Date.now() / 1000));
  
  const checkLogin = () => {
    console.log("checking login", timeout, username);
    if (username !== "" && username.length>0) {
      if (Math.floor(Date.now() / 1000) > parseFloat(timeout)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  const onIdle = () => {
    console.log("User is IDLE");
    setUsername("");
    setTimeout("0");
  };
  console.log('This is the path!!!',pathname)
  return userLoading ? (
    <div className="pageContent">
      <Spin style={{ Height: "200px" }} />
    </div>
  ) : (
    <div className="fullPage">
      <Router history={history}>
        
        {/* <SideBar /> */}
        <div className="pageContent">
        {
          <Switch>
            <Route path="/" exact component={() => <div style={{ padding: 32 }}><h1>Dynasty Dash</h1><p>Manage player values and MFL offers from the Trade Center.</p><Link to="/trade-center">Open Trade Center</Link></div>} />
            {/* <Route path="/login">
              {checkLogin() ? (
                <Redirect to="/" />
              ) : (
                <div className="login">
                  <LoginForm />
                </div>
              )}
            </Route> */}
            <Route path="/MyLeagues">
              {
                  !checkLogin() ? <LoginForm></LoginForm>:<MyLeagues />
              }
            </Route>
            <Route path="/mflLeagues">
                 {!checkLogin() ? <LoginForm></LoginForm>:<MflLeagues/>}
            </Route>
            <Route path="/waivers">
                 {!checkLogin() ? <LoginForm></LoginForm>:<WaiverClaims/>}
            </Route>
            <Route path="/lineups">
                 {!checkLogin() ? <LoginForm></LoginForm>:<Lineups/>}
            </Route>
            <Route path="/propbets">
                 {!checkLogin() ? <LoginForm></LoginForm>:<PropBets/>}
            </Route>
              <Route path="/trade-center">
                {!checkLogin() ? <LoginForm></LoginForm>:<TradeCenter/>}
              </Route>
            
            <Route path="/MyDash">
              {
                 !checkLogin() ? <LoginForm></LoginForm>: <MyDash />
              }
            </Route>
            <Route path="/MyRosters">
              {
                 !checkLogin() ? <LoginForm></LoginForm>: <MyRosters />
              }
            </Route>
            <Route path="/Admin">
              {
                  <Admin />
              }
            </Route>
            <Route path="/Projections">
            {!checkLogin() ? <LoginForm></LoginForm>:<Projections />}
            </Route>
            <Route path="/ProjectionsPosition">
                  <ProjectionsPosition />
            </Route>
            <Route path="/RDP">
                  <RDP />
            </Route>
            <Route path="/Trades">
              {!checkLogin() ? <LoginForm></LoginForm>:<TradeCenter/>}
            </Route>
            
          </Switch>
}
        </div>
      </Router>
    </div>
  );
}

export default App;
